const { fetcher } = require('services/helpers/responseHandler')

const internalAdminGet = async ({ merchantId, subsidiaryId, key }) =>
  fetcher.get(`merchantcontracts`, { merchantId, subsidiaryId, key })

const internalAdminUpdate = async ({
  merchantId,
  key,
  data,
  firstName,
  lastName,
  email,
  phone
}) =>
  fetcher.post(`merchantcontracts`, {
    merchantId,
    key,
    data,
    firstName,
    lastName,
    email,
    phone
  })

const addNewMerchantContact = async ({ merchantId, firstName, lastName, email, phone }) =>
  fetcher.post('merchantcontracts/save', {
    merchantId,
    updatingMerchantContacts: [],
    addingMerchantContacts: [
      {
        firstName,
        lastName,
        email,
        phone
      }
    ],
    deletingMerchantContactIds: [],
    addingMerchantContractDocuments: [],
    deletingMerchantContractDocumentIds: []
  })

const addNewMerchantDocument = async ({ merchantId, path, name }) =>
  fetcher.post('merchantcontracts/save', {
    merchantId,
    updatingMerchantContacts: [],
    addingMerchantContacts: [],
    deletingMerchantContactIds: [],
    addingMerchantContractDocuments: [{ path, name }],
    deletingMerchantContractDocumentIds: []
  })

const internalLinkGenerate = async ({ merchantId, key }) =>
  fetcher.post(`merchantcontracts/link`, { merchantId, key })

const internalAdminList = async () => fetcher.get(`merchantcontracts/list`)

const internalFinalize = async req => fetcher.post(`merchantcontracts/finalize`, req)

const userGet = async ({ linkKey }) =>
  fetcher.get(`merchantcontracts/groups/link`, { link: linkKey })

const userUpdate = async ({ linkKey, data }) =>
  fetcher.put(`merchantcontracts/groups`, { link: linkKey, data })

const userFinalize = async req => fetcher.post(`merchantcontracts/groups/finalize`, req)

const merchantDocumentsGet = async merchantId =>
  fetcher.get('merchantcontracts/document-contracts', { merchantId })

const subsidiaryDocumentsGet = async () =>
  fetcher.get('merchantcontracts/subsidiary/documents')

const getAddendum = async () => fetcher.get('merchantcontracts/addendum')
const postAddendum = async data => fetcher.post('merchantcontracts/addendum', data)

const getHotelStaff = async () => fetcher.get('merchantcontracts/hotel-staff')

const updateHotelStaff = async ({
  pmsIntegrationContactUserId,
  accountPayableUserId,
  gmUserId
}) =>
  fetcher.post('merchantcontracts/hotel-staff', {
    pmsIntegrationContactUserId,
    accountPayableUserId,
    gmUserId
  })

const addLegalInfoFile = async path =>
  fetcher.post('merchantcontracts/legal-info', {
    path
  })

const addLegalInfo = async data => fetcher.post('merchantcontracts/legal-info', data)

const getLegalInfo = async () => fetcher.get('merchantcontracts/legal-info')

const contractApi = {
  internalAdmin: {
    get: internalAdminGet,
    list: internalAdminList,
    update: internalAdminUpdate,
    linkGenerate: internalLinkGenerate,
    finalize: internalFinalize,
    addNewMerchantContact,
    addNewMerchantDocument
  },
  user: {
    get: userGet,
    update: userUpdate,
    finalize: userFinalize
  },
  addendum: {
    get: getAddendum,
    post: postAddendum
  },
  hotelStaff: {
    get: getHotelStaff,
    update: updateHotelStaff
  },
  lagelInfo: {
    addFile: addLegalInfoFile,
    add: addLegalInfo,
    get: getLegalInfo
  },
  documents: {
    merchant: merchantDocumentsGet,
    subsidiary: subsidiaryDocumentsGet
  }
}

export default contractApi
